import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { stats } from '@/mocks/comics';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们_89890漫画网_蜜桃少年漫画';

    const ids = ['schema-about', 'schema-faq'];
    ids.forEach((id) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    });

    const aboutScript = document.createElement('script');
    aboutScript.id = 'schema-about';
    aboutScript.type = 'application/ld+json';
    aboutScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于89890漫画网',
      description: '89890漫画网是国内领先的免费漫画在线阅读平台，提供蜜桃少年漫画大结局免费阅读服务。',
      url: 'https://www.89890.com/about',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.89890.com' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.89890.com/about' },
        ],
      },
    });
    document.head.appendChild(aboutScript);

    const faqScript = document.createElement('script');
    faqScript.id = 'schema-faq';
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '89890漫画网真的完全免费吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的！89890漫画网始终坚持免费阅读的宗旨，所有漫画包括蜜桃少年漫画大结局均可免费在线阅读，无需任何付费。',
          },
        },
        {
          '@type': 'Question',
          name: '蜜桃少年漫画大结局在哪里看？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '在89890漫画网首页即可找到蜜桃少年漫画的入口，点击进入漫画详情页后可以直接阅读最新话大结局。',
          },
        },
        {
          '@type': 'Question',
          name: '漫画更新频率是怎样的？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '89890漫画网每日更新大量漫画章节，热门连载作品通常保持每周更新的节奏。',
          },
        },
        {
          '@type': 'Question',
          name: '支持手机阅读吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '完全支持！89890漫画网采用响应式设计，在任何设备上都能获得流畅舒适的阅读体验。',
          },
        },
      ],
    });
    document.head.appendChild(faqScript);

    return () => {
      ids.forEach((id) => {
        const s = document.getElementById(id);
        if (s) s.remove();
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-900 font-medium whitespace-nowrap">关于我们</span>
            </nav>
          </div>
        </div>

        <section className="py-14 md:py-20">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
              <div className="lg:w-1/2">
                <div className="rounded-3xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20space%20with%20bookshelf%20and%20soft%20lamp%20light%2C%20artistic%20illustration%20style%2C%20gentle%20peach%20and%20cream%20tones%2C%20peaceful%20comforting%20atmosphere%2C%20modern%20clean%20composition%2C%20no%20text&width=800&height=600&seq=about-hero-01&orientation=landscape"
                    alt="89890漫画网 - 品牌形象"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex gap-3 mt-4">
                  <span className="px-4 py-2 text-xs font-medium bg-background-100/70 backdrop-blur-sm text-foreground-600 rounded-full whitespace-nowrap">高清画质</span>
                  <span className="px-4 py-2 text-xs font-medium bg-background-100/70 backdrop-blur-sm text-foreground-600 rounded-full whitespace-nowrap">免费阅读</span>
                  <span className="px-4 py-2 text-xs font-medium bg-background-100/70 backdrop-blur-sm text-foreground-600 rounded-full whitespace-nowrap">每日更新</span>
                </div>
              </div>

              <div className="lg:w-1/2">
                <h1 className="font-heading text-3xl md:text-5xl text-foreground-900 font-bold leading-tight">
                  关于
                  <span className="text-primary-500">89890</span>
                  <br />漫画网
                </h1>
                <div className="mt-5 flex flex-wrap gap-2">
                  <span className="px-3 py-1.5 text-xs font-medium border border-primary-300 text-primary-600 rounded-full whitespace-nowrap">品牌介绍</span>
                  <span className="px-3 py-1.5 text-xs font-medium text-foreground-400 rounded-full whitespace-nowrap">口碑信誉</span>
                  <span className="px-3 py-1.5 text-xs font-medium text-foreground-400 rounded-full whitespace-nowrap">联系方式</span>
                </div>

                <div className="mt-8 p-6 md:p-8 bg-background-900 rounded-2xl">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/20 text-primary-400 rounded-full">
                    我们的使命
                  </span>
                  <h2 className="mt-4 text-xl md:text-2xl font-heading text-background-50 font-bold">
                    让每一个漫画爱好者都能免费享受高清阅读
                  </h2>
                  <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
                    89890漫画网成立于2020年，是国内领先的免费漫画在线阅读平台。我们专注于为用户提供<strong>高清</strong>、<strong>流畅</strong>、<strong>免费</strong>的漫画阅读体验，收录了超过1.2万部各类题材的漫画作品，涵盖恋爱、校园、青春、奇幻等多种类型。主打<strong>蜜桃少年漫画</strong>系列，提供完整大结局免费阅读服务。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-bold">平台数据</h2>
              <p className="mt-3 text-sm text-foreground-500">我们用数据说话</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              <div className="text-center p-6 bg-background-50 rounded-2xl">
                <p className="font-heading text-3xl md:text-4xl text-primary-500 font-bold">{(stats.totalComics / 10000).toFixed(1)}万+</p>
                <p className="mt-2 text-sm text-foreground-500">漫画作品</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-2xl">
                <p className="font-heading text-3xl md:text-4xl text-accent-500 font-bold">{(stats.totalChapters / 10000).toFixed(1)}万+</p>
                <p className="mt-2 text-sm text-foreground-500">漫画章节</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-2xl">
                <p className="font-heading text-3xl md:text-4xl text-secondary-500 font-bold">{(stats.dailyVisits / 10000).toFixed(0)}万+</p>
                <p className="mt-2 text-sm text-foreground-500">日访问量</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-2xl">
                <p className="font-heading text-3xl md:text-4xl text-primary-400 font-bold">{(stats.registeredUsers / 10000).toFixed(0)}万+</p>
                <p className="mt-2 text-sm text-foreground-500">注册用户</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-[60%]">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
                  <span className="text-xs font-medium text-foreground-500 tracking-wide">用户口碑</span>
                </div>
                <blockquote className="font-heading text-2xl md:text-4xl text-foreground-900 leading-snug">
                  &ldquo;自从发现了89890漫画网，我就再也没去过其他平台。蜜桃少年漫画的大结局在这里免费高清看完，体验太好了！&rdquo;
                </blockquote>
                <div className="mt-6 flex items-center gap-3">
                  <span className="text-sm font-semibold text-foreground-800">漫画爱好者小陈</span>
                  <span className="flex items-center gap-1 text-accent-500 text-xs">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </span>
                  <span className="text-xs text-foreground-400">· 忠实用户3年</span>
                </div>
              </div>

              <div className="lg:w-[40%]">
                <div className="rounded-2xl overflow-hidden h-full min-h-[300px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20portrait%20silhouette%20of%20a%20person%20reading%20with%20soft%20golden%20light%2C%20artistic%20illustration%20style%2C%20gentle%20peach%20and%20cream%20tones%2C%20peaceful%20reading%20atmosphere%2C%20abstract%20minimal%20composition&width=600&height=800&seq=testimonial-01&orientation=portrait"
                    alt="89890漫画网用户口碑"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-bold">联系我们</h2>
              <p className="mt-3 text-sm text-foreground-500">有任何问题或建议，欢迎随时联系我们</p>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="p-6 bg-background-50 rounded-2xl text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-800">电子邮箱</h3>
                  <p className="mt-1 text-xs text-foreground-500">contact@89890.com</p>
                </div>
                <div className="p-6 bg-background-50 rounded-2xl text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-800">客服电话</h3>
                  <p className="mt-1 text-xs text-foreground-500">400-888-9890</p>
                </div>
                <div className="p-6 bg-background-50 rounded-2xl text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-wechat-line text-xl text-secondary-500"></i>
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-800">微信公众号</h3>
                  <p className="mt-1 text-xs text-foreground-500">89890漫画网</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-bold text-center mb-10">常见问题</h2>
            <div className="max-w-3xl mx-auto space-y-4">
              <details className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                  <span className="text-sm font-semibold text-foreground-800">89890漫画网真的完全免费吗？</span>
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  是的！89890漫画网始终坚持免费阅读的宗旨，所有漫画包括蜜桃少年漫画大结局均可免费在线阅读，无需任何付费。我们通过广告收入维持平台运营，为用户提供高清流畅的阅读体验。
                </div>
              </details>
              <details className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                  <span className="text-sm font-semibold text-foreground-800">蜜桃少年漫画大结局在哪里看？</span>
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  在89890漫画网首页即可找到蜜桃少年漫画的入口，点击进入漫画详情页后可以直接阅读最新话大结局。您也可以通过搜索功能输入"蜜桃少年"快速找到该漫画。
                </div>
              </details>
              <details className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                  <span className="text-sm font-semibold text-foreground-800">漫画更新频率是怎样的？</span>
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  89890漫画网每日更新大量漫画章节，热门连载作品通常保持每周更新的节奏。您可以在首页"最新更新"区域查看当日更新的所有漫画章节，不错过任何精彩内容。
                </div>
              </details>
              <details className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                  <span className="text-sm font-semibold text-foreground-800">支持手机阅读吗？</span>
                  <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                </summary>
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  完全支持！89890漫画网采用响应式设计，无论在电脑、平板还是手机上都能获得流畅舒适的阅读体验。您可以在任何设备上随时随地畅享免费漫画阅读。
                </div>
              </details>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}